import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../ui-kit/theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    wrap: {
      width: "100%",
      "& > * + *": { marginTop: 16 },
    },
    panel: {
      width: "100%",
      backgroundColor: UIKIT_COLORS.PRIMARY_LIGHT_BG,
      border: `1px solid ${UIKIT_COLORS.PRIMARY}`,
      borderRadius: 8,
      padding: "17px 20px",
      boxSizing: "border-box",
      "& > * + *": { marginTop: 12 },
    },
    panelHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    panelTitle: {
      fontSize: 13,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_SECONDARY,
      lineHeight: "18px",
    },
    clearAllBtn: {
      background: "none",
      border: "none",
      padding: 0,
      minWidth: "unset",
      fontSize: 13,
      fontWeight: 500,
      color: `${UIKIT_COLORS.PRIMARY} !important`,
      lineHeight: "18px",
      textTransform: "none",
      "&:hover": { textDecoration: "underline", background: "none" },
    },

    // ── Radio row ────────────────────────────────────────────────────────────
    radioRow: {
      display: "flex",
      alignItems: "flex-start",
      cursor: "pointer",
      userSelect: "none" as const,
      "& > * + *": { marginLeft: 10 },
    },
    radioCircle: {
      width: 20,
      height: 20,
      flexShrink: 0,
      borderRadius: "50%",
      border: `2px solid #9CA3AF`,
      backgroundColor: UIKIT_COLORS.WHITE,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box" as const,
      marginTop: 2,
    },
    radioCircleSelected: {
      border: `2px solid ${UIKIT_COLORS.PRIMARY}`,
      backgroundColor: UIKIT_COLORS.PRIMARY,
    },
    radioDot: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: UIKIT_COLORS.WHITE,
      flexShrink: 0,
    },
    radioLabel: {
      fontSize: 14,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_FIELD,
      lineHeight: "20px",
      wordBreak: "break-word" as const,
      overflowWrap: "break-word" as const,
      minWidth: 0,
    },

    // ── Comment textarea ─────────────────────────────────────────────────────
    commentWrap: {
      display: "flex",
      flexDirection: "column",
      "& > * + *": { marginTop: 6 },
    },
    commentLabel: {
      fontSize: 13,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_SECONDARY,
      lineHeight: "18px",
    },
    commentTextarea: {
      width: "100%",
      resize: "vertical" as const,
      border: `1px solid ${UIKIT_COLORS.PRIMARY}`,
      borderRadius: 6,
      padding: "10px 12px",
      fontSize: 14,
      fontFamily: "'Montserrat', sans-serif",
      color: UIKIT_COLORS.TEXT_PRIMARY,
      backgroundColor: UIKIT_COLORS.WHITE,
      outline: "none",
      boxSizing: "border-box" as const,
      lineHeight: "20px",
    },

    // ── Actions ──────────────────────────────────────────────────────────────
    actions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& > * + *": { marginLeft: 16 },
    },
    cancelBtn: {
      border: `2px solid ${UIKIT_COLORS.PRIMARY} !important`,
      borderRadius: 12,
      minHeight: "unset",
      fontSize: 14,
      fontWeight: 700,
      color: `${UIKIT_COLORS.PRIMARY} !important`,
      backgroundColor: "transparent !important",
      lineHeight: "20px",
      textTransform: "none",
      "& .MuiButton-label": { fontSize: 14, fontWeight: 700 },
      "&:hover": { backgroundColor: `rgba(14,90,167,0.05) !important` },
    },
    confirmBtn: {
      backgroundColor: `${UIKIT_COLORS.PRIMARY} !important`,
      border: "none",
      borderRadius: 12,
      fontSize: 14,
      fontWeight: 700,
      color: `${UIKIT_COLORS.WHITE} !important`,
      lineHeight: "20px",
      textTransform: "none",
      "& .MuiButton-label": { fontSize: 14, fontWeight: 700 },
      "&:hover": { backgroundColor: `${UIKIT_COLORS.PRIMARY_HOVER} !important` },
      "&.Mui-disabled": { backgroundColor: `${UIKIT_COLORS.PRIMARY} !important`, opacity: 0.4 },
    },
  })
);
